import {http_build_query} from '@utils'
import store from '@/store'

let loginMixinsHolder = []

let loginComponent = {
    component: false,
    componentAttrs: false,
    componentEvents: false
}

class AuthHelper
{
    handleSpecialResponse(response)
    {
        if( response.getData('_authRedirect_', false) ) {
            this.handlePluginRedirect(response)
        }
        else if ( response.getData('_authCompleted_', false) ) {
            this.handleLoginComplete(response)
        }
    }

    handlePluginRedirect(response)
    {
        // response.getData('session')

        store.commit('auth/LOADING', false)

        app.$router.push(
            response.getData('route')
        )
    }

    handleLoginComplete(response)
    {
        // response.getData('session')

        app.$addFlashMessage(response.getMessage(), 'success')

        app.$root.authInfo.username = response.getData('user').username

        if( app.$root.isClient ) {
            let queryParams = {
                code: response.getData('authCode'),
                embed: _appConfig.embed
            }

            if( _appConfig.client.state ) {
                queryParams.state = _appConfig.client.state
            }

            if( _appConfig.client.return_url ) {
                queryParams.return_url = _appConfig.client.return_url
            }

            window.location.href = this.getRedirectURI(queryParams)

            window._appRedirected = true // prevent the next router actions
        } else {
            store.commit('auth/LOADING', false)

            app.$router.push({
                path: '/app/dashboard'
            })
        }
    }

    alreadyLogged()
    {
        window._appRedirected = true // prevent the next router actions

        let queryParams = {
            embed: _appConfig.embed
        }

        if( _appConfig.client.return_url ) {
            queryParams.return_url = _appConfig.client.return_url
        }

        let url = this.getRedirectURI(queryParams)

        url = url.replace('/callback', '/already-logged')

        window.location.href = url
    }

    getRedirectURI(options = {})
    {
        var queryString = http_build_query(options)

        var redirectURI = _appConfig.client.redirect_uri
        if ( redirectURI.indexOf('?') !== -1 ) {
            redirectURI += '&' + queryString
        } else {
            redirectURI += '?' + queryString
        }

        return redirectURI
    }

    getLoginComponent() {
        return loginComponent
    }

    setLoginComponent(info) {
        loginComponent = Object.assign(loginComponent, info)
    }

    loginMixins() {
        return loginMixinsHolder
    }

    registerLoginMixin(mixin) {
        loginMixinsHolder.push(mixin)
    }

    clearLoginMixins() {
        loginMixinsHolder = []
    }
}

export default new AuthHelper()
